import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hms'
})
export class HourMinuteSecondsPipe implements PipeTransform {

  transform(value: any): string {
    var sec_num = parseInt(value, 10); // don't forget the second param
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    var seconds = sec_num - (hours * 3600) - (minutes * 60);

    return (hours > 9 ? hours : `0${hours}`.slice(-2)) + ':' + (minutes > 9 ? minutes : `0${minutes}`.slice(-2)) + ':' + ((seconds) > 9 ? seconds : `0${seconds}`.slice(-2));
  }

}
